<div class="ignored-repaired-card">
  <table
    mat-table
    matSort
    id="asset-closed-defect-table"
    [dataSource]="dataSource"
    matSortActive="severity"
    matSortDirection="desc"
    matSortDisableClear="true"
    (matSortChange)="onMatSortChange($event)"
  >
    <ng-container
      matColumnDef="{{ column.column }}"
      *ngFor="let column of displayedColumnGroup"
    >
      <ng-container *ngTemplateOutlet="column.sortable ? sortableHeader : nonSortableHeader; context: { $implicit: column.displayName }"></ng-container>
      <ng-template #sortableHeader let-columnName>
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          scope="col"
        >
          {{ columnName }}
        </th>
      </ng-template>
      <ng-template #nonSortableHeader let-columnName>
        <th
          mat-header-cell
          *matHeaderCellDef
          scope="col"
        >
          {{ columnName }}
        </th>
      </ng-template>
      <ng-container *ngIf="column.column === 'severity'">
        <td
          mat-cell
          *matCellDef="let element"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
          >
            <img [src]="getSeverityIcon(element[column.column])"
              [alt]="element[column.column] ? (('severity' | i18next) + ' ' + element[column.column]) : ('severity' | i18next)" />
            <img
              class="arrow-icon"
              src="/assets/arrow.svg"
              alt=""
            />
            <img src="/assets/severity-none.svg" [alt]="'repaired' | i18next" />
          </div>
        </td>
      </ng-container>
      <ng-container *ngIf="column.column === 'inspection'">
        <td
          mat-cell
          *matCellDef="let element"
        >
          <a routerLink="/company/{{ companyId }}/inspection/{{ element.inspectionId }}">
            {{ element[column.column] }}
          </a>
        </td>
      </ng-container>
      <ng-container *ngIf="column.column !== 'severity' && column.column !== 'inspection'">
        <td
          mat-cell
          *matCellDef="let element"
        >
          {{ element[column.column] }}
        </td>
      </ng-container>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>

  <app-no-results-card
    *ngIf="noDefects"
    [message]="repairDefectString"
  ></app-no-results-card>

  <div [hidden]="noDefects">
    <app-paginator
      #appPaginator
      [length]="totalClosedDefects"
      [pageSizeOptions]="pageSizeOptions"
      (pageQueryChange)="onQueryChange($event)"
    ></app-paginator>
  </div>
</div>
